import { useRef } from "react";
import { useIsoMorphicEffect as n } from "./use-iso-morphic-effect.js";
function s(n$1, t) {
  let e = useRef({ left: 0, top: 0 });
  if (n(() => {
    if (!t) return;
    let r = t.getBoundingClientRect();
    r && (e.current = r);
  }, [n$1, t]), t == null || !n$1 || t === document.activeElement) return false;
  let o = t.getBoundingClientRect();
  return o.top !== e.current.top || o.left !== e.current.left;
}
export {
  s as useDidElementMove
};
